<div class="dialog mfp-white-box" [ngClass]="{'dialog--fixed-size': size === 'fixed'}">
  <img
    mfpLazyImage
    class="dialog__close"
    lazySrc="assets/icons/close.svg"
    (click)="closeOnCancel()"
  />
  <img
    mfpLazyImage
    class="dialog__icon"
    lazySrc="assets/icons/{{ type }}.svg"
  />
  <ng-container *ngIf="title">
    <h1 class="dialog__title">{{ title }}</h1>
  </ng-container>
  <p class="dialog__text">{{ text }}</p>
  <div class="dialog__divider"></div>
  <div class="dialog__actions">
    <ng-container *ngIf="cancelAction">
      <mfp-button
        class="dialog__button dialog__button-first"
        type="button"
        color="primary"
        fill="outline"
        [label]="cancelAction"
        [disabled]="false"
        (click)="closeOnCancel()"
      >
      </mfp-button>
    </ng-container>
    <mfp-button
      class="dialog__button"
      type="button"
      color="primary"
      [label]="successAction"
      [disabled]="false"
      (click)="closeOnSuccess()"
    ></mfp-button>
  </div>
</div>
